module.exports = "https://static.energy5.com/_next/static/images/slide3-e45a9ee9bcc26680de36ac1f8ffd25b6.png";